import axios from 'axios';

export async function getGenialGuardPlans() {
  const response = await axios.get('/genial-guard/plans');
  return response.data;
}

export async function registerGenialGuard(data) {
  const response = await axios.post('/genial-guard/register', data);
  return response.data;
} 
